import Truncate from 'react-truncate';

const sanitizeHtml = require('sanitize-html');
const entities = require('entities');
const React = require('react');

const extractText = htmlString => {
    const textWithEntities = sanitizeHtml(htmlString, {
        allowedTags: [],
        allowedAttributes: []
    });
    const text = entities.decodeHTML(textWithEntities);
    return text;
};

export default ({ children, lines }) => {
    const text = extractText(children);
    if (global.window && global.window.requestAnimationFrame) {
        return <Truncate lines={lines}>{ text }</Truncate>;
    } else {
        return <span>{text}</span>;
    }
};
